// 🔧 sponsor_seeder.js
// ✅ Purpose: Coordinates persistence of Sponsor Engine demo data
// ✅ Features:
// - Seeds Sponsor Levels
// - Seeds Sponsors
// - Delegates all Firestore writes to the repository
// - Returns normalized Sponsor Engine results
// - Fully block-commented for clarity and future devs

import {
  saveSponsorLevels,
  saveSponsors,
} from "./sponsor_repository";

export const seedSponsors = async ({
  demoContext,
  sponsorPlan,
} = {}) => {
  console.log("🌱 Sponsor Seeder started.");

  const sponsorLevels =
    sponsorPlan?.sponsorLevels || [];

  const sponsors =
    sponsorPlan?.sponsors || [];

  // =====================================================
  // Persist Sponsor Levels.
  // =====================================================

  await saveSponsorLevels({
    demoContext,
    sponsorLevels,
  });

  // =====================================================
  // Persist Sponsors.
  // =====================================================

  const createdSponsors = await saveSponsors({
    demoContext,
    sponsors,
  });

  console.log("✅ Sponsor Seeder completed.", {
    sponsorLevels: sponsorLevels.length,
    sponsors: sponsors.length,
  });

  return {
    sponsorLevels,
    sponsors: createdSponsors,
  };
};
